<template>
  <div class="physical-list">
    <input-form
      ref="inputForm"
      :inputData="inputData"
      :btnPosition1="true"
      @export_get="export_get"
      @toParentVal="searchContent"
    ></input-form>
    <div class="table-box">
      <div class="btn-top">
        <el-button type="primary" style="width: auto;" @click="handleCreate"
          >批量标记发货</el-button
        >
        <el-button @click="exportRecord" v-preventReClick>导出</el-button>
      </div>
      <el-table
        :data="tableData"
        v-loading="tableLoading"
        :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
        :cell-style="{ 'text-align': 'left' }"
        style="width: 100%"
      >
        <template slot="empty">
          <div>
            <img
              src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/noData.png"
            />
            <span style="margin-left: -140px">暂无任何数据</span>
          </div>
        </template>
        <el-table-column prop="chaosPin" label="用户pin（加密）" width="150">
        </el-table-column>
        <el-table-column prop="memberNick" label="用户昵称" width="150">
          <template slot-scope="scope">
            <div v-if="scope.row.memberNick">
              {{ scope.row.memberNick }}
            </div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="recordId"
          label="中奖ID"
          width="120"
        ></el-table-column>
        <el-table-column prop="activitySubType" label="活动类型" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.activitySubType == 1"> 签到赢好礼 </span>
            <span v-if="scope.row.activitySubType == 2"> 浏览礼品有礼 </span>
            <span v-if="scope.row.activitySubType == 3"> 每日限时抢 </span>
            <span v-if="scope.row.activitySubType == 4"> 关注店铺有礼 </span>
            <span v-if="scope.row.activitySubType == 5"> 邀请开卡有礼 </span>
            <span v-if="scope.row.activitySubType == 6"> 邀请关注有礼 </span>
            <span v-if="scope.row.activitySubType == 7"> 完善信息有礼 </span>
            <span v-if="scope.row.activitySubType == 8"> 幸运抽奖 </span>
            <span v-if="scope.row.activitySubType == 9"> 积分兑换实物 </span>
            <span v-if="scope.row.activitySubType == 10">
              积分兑换优惠券
            </span>
            <span v-if="scope.row.activitySubType == 11"> 新人优惠券 </span>
            <span v-if="scope.row.activitySubType == 12"> 会员优惠券 </span>
            <span v-if="scope.row.activitySubType == 13">开卡礼包</span>
            <span v-if="scope.row.activitySubType == 14">店铺礼包</span>
            <span v-if="scope.row.activitySubType == 15"
              >店铺礼包（千人千面）</span
            >
            <span v-if="scope.row.activitySubType == 16">下单有礼</span>
            <span v-if="scope.row.activitySubType == 17">首单专享礼</span>
            <span v-if="scope.row.activitySubType == 18">复购有礼</span>
            <span v-if="scope.row.activitySubType == 19">下单抽奖</span>
            <span v-if="scope.row.activitySubType == 20">评价有礼</span>
            <span v-if="scope.row.activitySubType == 21">裂变神券</span>
            <span v-if="scope.row.activitySubType == 22">天降红包雨</span>
            <span v-if="scope.row.activitySubType == 23">欢乐娃娃机</span>
            <span v-if="scope.row.activitySubType == 24">大家来找茬</span>
            <span v-if="scope.row.activitySubType == 25">智能活动海报</span>
            <span v-if="scope.row.activitySubType == 26">刮刮乐</span>
            <span v-if="scope.row.activitySubType == 27">预售有礼</span>
            <span v-if="scope.row.activitySubType == 28">预售抽奖</span>
            <span v-if="scope.row.activitySubType == 31">超级裂变券</span>
            <span v-if="scope.row.activitySubType == 32">会员卡片</span>
            <span v-if="scope.row.activitySubType == 33">0元试用</span>
            <span v-if="scope.row.activitySubType == 34">加购有礼</span>
            <span v-if="scope.row.activitySubType == 36">下单冲榜</span>
            <span v-if="scope.row.activitySubType == 39">生日有礼</span>
            <span v-if="scope.row.activitySubType == 41">晒单有礼</span>
            <span v-if="scope.row.activitySubType == 40">专属赠礼品</span>
          </template>
        </el-table-column>
        <el-table-column prop="activityName" label="活动名称" width="150">
        </el-table-column>
        <el-table-column
          prop="goodsName"
          label="奖品名称"
          width="150"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.goodsName }}
            </div>
            <div>id：{{ scope.row.goodsId }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="joinTime"
          label="参与时间"
          width="160"
        ></el-table-column>
        <el-table-column prop="grantTime" label="发货时间" width="160">
          <template slot-scope="scope">
            <div v-if="scope.row.grantTime">
              {{ scope.row.grantTime }}
            </div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="发货状态" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.status == '5'">已发货</span>
            <span
              v-if="
                scope.row.status == '2' ||
                  scope.row.status == '3' ||
                  scope.row.status == '7'
              "
              >未发货</span
            >
          </template>
        </el-table-column>
        <el-table-column prop="receiverName" label="收件人" width="120">
          <template slot-scope="scope">
            <div class="open" v-if="scope.row.receiverName">
              {{ scope.row.receiverName }}
              <div
                class="openHover"
                v-if="
                  scope.row.receiverMobile &&
                    scope.row.receiverName.indexOf('*') != -1
                "
                @click="
                  handleDecrypt(
                    'receiverName',
                    'tableData',
                    scope.row,
                    scope.$index
                  )
                "
              >
                展开
              </div>
            </div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column prop="receiverMobile" label="收件人手机号" width="120">
          <template slot-scope="scope">
            <div class="open" v-if="scope.row.receiverMobile">
              {{ scope.row.receiverMobile }}
              <div
                class="openHover"
                v-if="
                  scope.row.receiverMobile &&
                    scope.row.receiverMobile.indexOf('*') != -1
                "
                @click="
                  handleDecrypt(
                    'receiverMobile',
                    'tableData',
                    scope.row,
                    scope.$index
                  )
                "
              >
                展开
              </div>
            </div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column prop="receiverAddress" label="收件人地区" width="210">
          <template slot-scope="scope">
            <div class="open" v-if="scope.row.receiverAddress">
              {{ scope.row.receiverAddress }}
              <div
                class="openHover"
                v-if="
                  scope.row.receiverAddress &&
                    scope.row.receiverAddress.indexOf('*') != -1
                "
                @click="
                  handleDecrypt(
                    'receiverAddress',
                    'tableData',
                    scope.row,
                    scope.$index
                  )
                "
              >
                展开
              </div>
            </div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="detailedAddress"
          label="收件人详细地址"
          width="210"
        >
          <template slot-scope="scope">
            <div class="open" v-if="scope.row.detailedAddress">
              {{ scope.row.detailedAddress }}
              <div
                class="openHover"
                v-if="
                  scope.row.detailedAddress &&
                    scope.row.detailedAddress.indexOf('*') != -1
                "
                @click="
                  handleDecrypt(
                    'detailedAddress',
                    'tableData',
                    scope.row,
                    scope.$index
                  )
                "
              >
                展开
              </div>
            </div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column prop="receiverCode" label="邮编" width="120">
          <template slot-scope="scope">
            <div v-if="scope.row.receiverCode">
              {{ scope.row.receiverCode }}
            </div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column prop="billCode" label="快递订单号" width="120">
          <template slot-scope="scope">
            <div v-if="scope.row.billCode">
              {{ scope.row.billCode }}
            </div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="200">
          <template slot-scope="scope">
            <div style="display: flex;">
              <el-button
                v-if="
                  (scope.row.status == 2 ||
                  scope.row.status == 3 ||
                  scope.row.status == 7) &&
                  scope.row.activitySubType != 40
                "
                type="text"
                @click="changeShip(scope.row)"
                >标记发货</el-button
              >
              <el-button v-if="scope.row.activitySubType != 40" type="text" @click="handleEnterCoutierNum(scope.row)"
                >录入快递单号</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="grantForm.current"
        :page-sizes="[10, 30, 50, 100]"
        :page-size="grantForm.size"
        layout="total, sizes, prev, pager, next, jumper"
        class="pagination"
        :total="total"
      ></el-pagination>
    </div>
    <!-- 批量标记发货 -->
    <el-dialog
      title="批量发货"
      width="580px"
      :visible.sync="physicalBatchShipmentShow"
      @close="physicalBatchShipmentClose"
      class="physical_batch_shipment_dialog"
    >
      <el-form label-width="120px" class="new-input-box">
        <el-form-item label="上传文件：">
          <el-upload
            :before-upload="beforeUploadFile"
            :on-success="handleUpload"
            :show-file-list="false"
            class="upload-demo"
            :drag="true"
            :data="{
              type: 1,
            }"
            multiple
            with-credentials
            :action="
              '/jd-hd-web/lockRight/goods/markingSendStatusBatch/fileUpload'
            "
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <!-- 下载模板按钮 -->
      <div class="download_template_box">
        <el-button type="primary" @click="handleDownloadTemplate"
          >下载模板</el-button
        >
      </div>
      <div class="downloadMsgBox">
        <p>
          导入成功{{ downloadResData.successNum }}条，导入失败{{
            downloadResData.failNum
          }}条，导入失败相关用户昵称：
        </p>
        <div class="downloadUser">
          <div
            class="downloaditem"
            v-for="(item, index) in downloadUserList"
            :key="index"
          >
            {{ index + 1 + ". " }}{{ item }}
          </div>
        </div>
      </div>
      <div class="physical_batch_shipment_dialog_floor">
        <el-button @click="physicalBatchShipmentClose">关闭</el-button>
      </div>
    </el-dialog>
    <!-- 录入快递单号弹窗 -->
    <el-dialog
      title="录入快递单号"
      width="420px"
      :visible.sync="enterCoutierNumShow"
      @close="blankEnterCoutierNum"
      class="enter_coutier_num_dialog"
    >
      <el-form
        :model="enterCoutierFrom"
        label-width="86px"
        class="new-input-box"
      >
        <el-form-item label="快递单号：">
          <el-input
            placeholder=""
            v-model="enterCoutierNum"
            style="width: 250px"
            @keydown.native="clearInput"
          ></el-input>
        </el-form-item>
      </el-form>
      <div style="text-align: center;">
        <el-button
          type="primary"
          @click="goodsEnterCoutierSubmit"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <!-- 导出身份验证 -->
    <el-dialog
      v-if="dialogExprot"
      title="身份验证"
      custom-class="system-dialog"
      :visible.sync="dialogExprot"
      width="500px"
      @close="dialogExprot = false"
    >
      <div class="form-box">
        <div class="form-item">
          <div class="item-label">
            手机号：
          </div>
          <div class="item-value">
            <el-input
              disabled
              placeholder="请输入..."
              v-model="loginUserInfo.mobile"
              style="width: 280px"
            ></el-input>
          </div>
        </div>
        <div class="form-item">
          <div class="item-label">
            验证码：
          </div>
          <div class="item-value">
            <el-input
              placeholder="请输入"
              v-model="code"
              style="width: 170px; margin-right: 12px"
            ></el-input>
            <el-button
              type="primary"
              :disabled="codeDisabled"
              @click="getCode"
              >{{ codeMsg }}</el-button
            >
          </div>
        </div>
      </div>

      <div class="save-btn">
        <el-button @click="dialogExprot = false">取消</el-button>
        <el-button type="primary" @click="getApi_Exprot">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
import inputForm from "@/components/inputForm";
import {
  getSendRecord,
  exportSendRecord,
} from "@/api/integralCenter/physical.js";
import {
  getExportCode,
  signIssuance,
  markingSendStatusLockRight,
} from "@/api/integralCenter/PointActivityAnalyticController";
import { querySellerSetting } from "@/api/userInform";
export default {
  components: {
    inputForm,
  },
  props: {
    goodsId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      enterCoutierRowData: {},
      enterCoutierNum: "",
      enterCoutierNumShow: false,
      dialogExprot: false,
      code: "",
      countdown: 60,
      codeDisabled: false,
      codeMsg: "获取验证码",
      physicalBatchShipmentShow: false,
      grantForm: {
        pin: "",
        recordId: "",
        joinStartTime: "",
        joinEndTime: "",
        activitySubType: "",
        goodsId: "",
        commitAddressFlag: "",
        status: "",
        current: 1,
        size: 10,
      },
      inputData: [
        {
          name: "用户pin",
          val: "pin",
          placeholder: "请输入",
        },
        {
          name: "中奖id",
          val: "recordId",
          placeholder: "请输入",
        },
        {
          name: "参与时间",
          myDate: true,
          val: ["joinStartTime", "joinEndTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "活动名称",
          val: "activityName",
          placeholder: "请输入",
        },
        {
          name: "活动类型",
          val: "activitySubType",
          placeholder: "请选择",
          selectArr: [
            {
              id: "",
              label: "全部",
            },
            {
              id: 1,
              label: "签到赢好礼",
            },
            {
              id: 3,
              label: "每日限时抢",
            },
            {
              id: 4,
              label: "关注店铺有礼",
            },
            {
              id: 5,
              label: "邀请开卡有礼",
            },
            {
              id: 6,
              label: "邀请关注有礼",
            },
            {
              id: 7,
              label: "完善信息有礼",
            },
            {
              id: 8,
              label: "幸运抽奖",
            },
            {
              id: 16,
              label: "下单有礼",
            },
            {
              id: 17,
              label: "首单专享礼",
            },
            {
              id: 18,
              label: "复购有礼",
            },
            {
              id: 19,
              label: "下单抽奖",
            },
            {
              id: 20,
              label: "评价有礼",
            },
            {
              id: 22,
              label: "天降红包雨",
            },
            {
              id: 23,
              label: "欢乐娃娃机",
            },
            {
              id: 24,
              label: "大家来找茬",
            },
            {
              id: 27,
              label: "预售有礼",
            },
            {
              id: 28,
              label: "预售抽奖",
            },
            {
              id: 34,
              label: "加购有礼",
            },
            {
              id: 36,
              label: "下单冲榜",
            },
            {
              id: 39,
              label: "生日有礼",
            },
            {
              id: 41,
              label: "晒单有礼",
            },
            {
              id: 40,
              label: "专属赠礼品",
            },
          ],
        },
        {
          name: "实物ID/名称",
          val: "goodsId",
          placeholder: "请输入",
        },
        {
          name: "是否提交地址",
          val: "commitAddressFlag",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: "" },
            { label: "已提交", id: 1 },
            { label: "未提交", id: 0 },
          ],
        },
        {
          name: "发货状态",
          val: "status",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: "" },
            { label: "已发货", id: "5" },
            { label: "未发货", id: "2,7" },
          ],
        },
      ],
      tableData: [],
      tableLoading: false,
      total: 0,
      downloadResData: {
        successNum: 0,
        failNum: 0,
      },
      downloadUserList: [],
      exportData: {},
      control: false,
    };
  },
  computed: {
    ...mapState(["loginUserInfo"]),
  },
  watch: {},
  mounted() {
    this.grantForm.goodsId = this.goodsId;
    this.$nextTick(() => {
      this.$refs.inputForm.form.goodsId = this.goodsId;
      this.$refs.inputForm.formSearch();
    });
  },
  methods: {
    // 获取当前信息，判断导出身份验证开关状态
    async getDownloadVerify() {
      try {
        const res = await querySellerSetting();
        if (res.code === 1) {
          return res.data.isOpenDownloadRemind === 0;
        } else {
          return false;
        }
      } catch (error) {
        return false;
      }
    },
    // 录入快递单号提交
    goodsEnterCoutierSubmit() {
      let params = {
        id: this.enterCoutierRowData.sendId,
        billCode: this.enterCoutierNum,
        deliveryFlag: 2
      };
      markingSendStatusLockRight(params)
        .then((res) => {
          if (res.code == 1) {
            this.blankEnterCoutierNum();
            this.getList();
          } else {
            this.$message.error(res.message);
          }
        })
        .catch(() => {
          this.$message.error("录入快递单号失败");
        });
    },
    // 置空录入快递单号输入框并关闭弹窗
    blankEnterCoutierNum() {
      this.enterCoutierNum = "";
      // 清除当前行存储数据
      this.enterCoutierRowData = {};
      this.enterCoutierNumShow = false;
    },
    // 录入快递单号
    handleEnterCoutierNum(row) {
      this.enterCoutierNum = row.billCode;
      this.enterCoutierRowData = row;
      // 打开弹窗
      this.enterCoutierNumShow = true;
    },
    //标记发货
    changeShip(row) {
      this.$confirm("是否标记为发货?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass: "iconfont iconicon-jinggao1",
      }).then(() => {
        signIssuance({ id: row.recordId })
          .then((res) => {
            if (res && res.code == 1) {
              this.$message.success(res.message);
              this.getList();
            } else {
              this.$message.error(res.message);
            }
          })
          .catch((res) => {});
      });
    },
    // 点击解密  name: 修改的字段名   objdata：数组的名称, params:接口的参数  item：点击的对象    index：数组传下标值
    handleDecrypt(name, objdata, item, index) {
      let params =
        "decrypt" + name[0].toUpperCase() + name.substring(1, name.length);
      this.$decrypt
        .decrypt({ decryptContent: item[`${params}`] })
        .then((res) => {
          this[`${objdata}`][index][`${name}`] = res.message;
        });
    },
    async getList() {
      this.tableLoading = true;
      try {
        const res = await getSendRecord(this.grantForm);
        if (res.code == 1) {
          this.tableLoading = false;
          this.tableData = res.data.records;
          this.total = Number(res.data.total);
        }
      } catch (error) {
        this.tableLoading = false;
      }
    },
    handleCreate() {
      this.physicalBatchShipmentShow = true;
    },
   async exportRecord() {
      const isShowVerify = await this.getDownloadVerify()
      if( !isShowVerify ) {
        let params = {
        ...this.exportData,
      };
      exportSendRecord(params)
        .then((res) => {
          let fileName1 = res.fileName.substring(res.fileName.indexOf("-"),res.fileName.length-1);
          let fileName2 =
            "实物奖品发送记录" +
            "-" +
            this.loginUserInfo.sellerNick + fileName1;
          if (res.code == 1) {
            this.dialogExprot = false;
            const href = URL.createObjectURL(res.blob);
            const a = document.createElement("a");
            a.style.display = "none";
            a.setAttribute("href", href);
            a.download = fileName2;
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(href);
          } else {
            this.$message.error("导出失败");
          }
        })
        .catch(() => {});
        return
      }
      clearInterval(this.timer);
      this.codeMsg = "获取验证码";
      this.code = "";
      this.countdown = 60;
      this.codeDisabled = false;
      this.dialogExprot = true;
      this.$refs.inputForm.export_fun();
    },
    export_get(params) {
      this.exportData = params;
    },
    getCode() {
      // 验证码60秒倒计时
      if (!this.codeDisabled) {
        getExportCode().then((res) => {
          if (res.code == 1) {
            this.codeDisabled = true;
            this.$message.success("验证码发送成功");
            this.timer = setInterval(() => {
              if (this.countdown > 0 && this.countdown <= 60) {
                this.countdown--;
                if (this.countdown !== 0) {
                  this.codeMsg = "已发送(" + this.countdown + "s)";
                } else {
                  clearInterval(this.timer);
                  this.codeMsg = "重新获取";
                  this.countdown = 60;
                  this.timer = null;
                  this.codeDisabled = false;
                }
              }
            }, 1000);
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    getApi_Exprot() {
      let params = {
        ...this.exportData,
        code: this.code,
      };
      exportSendRecord(params)
        .then((res) => {
          let fileName1 = res.fileName.substring(res.fileName.indexOf("-"),res.fileName.length-1);
          let fileName2 =
            "实物奖品发送记录" +
            "-" +
            this.loginUserInfo.sellerNick + fileName1;
          if (res.code == 1) {
            this.dialogExprot = false;
            const href = URL.createObjectURL(res.blob);
            const a = document.createElement("a");
            a.style.display = "none";
            a.setAttribute("href", href);
            a.download = fileName2;
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(href);
          } else {
            this.$message.error("导出失败");
          }
        })
        .catch(() => {});
    },
    // 上传文件处理
    beforeUploadFile(file) {
      this.loading = true;
    },
    // 上传文件回调
    handleUpload(res) {
      // 上传文件
      if (res.code == 0) {
        this.$message.error(res.message);
      } else if (res.code == 1) {
        this.downloadResData = res.data;
        this.downloadUserList = res.data.failUserName;
        this.$message.success("上传成功");
      }
    },
    // 下载模板
    handleDownloadTemplate() {
      let url =
        "https://yeion-public.s3.cn-north-1.jdcloud-oss.com/template/%E6%89%B9%E9%87%8F%E5%8F%91%E8%B4%A7%E6%A8%A1%E6%9D%BF2.xlsx";
      let fileName = "实物奖品发送记录批量发货模板.xlsx";
      let elem = document.createElement("a");
      elem.style.display = "none";
      elem.href = url;
      elem.setAttribute("download", fileName);
      document.body.appendChild(elem);
      elem.click();
    },
    physicalBatchShipmentClose() {
      this.physicalBatchShipmentShow = false;
      this.downloadResData = {};
      this.downloadUserList = [];
      this.getList();
    },
    handleSizeChange(val) {
      this.grantForm.size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.grantForm.current = val;
      this.getList();
    },
    searchContent(val) {
      this.grantForm = {
        ...val,
        current: 1,
        size: 10
      };
      this.grantForm.joinStartTime = val.joinStartTime ? val.joinStartTime : "";
      this.grantForm.joinEndTime = val.joinEndTime ? val.joinEndTime : "";
      this.getList();
    },
  },
};
</script>
<style lang="scss" scoped>
.physical-list {
  margin-top: 20px;
  height: 100%;
}
.btn-top {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
.physical_batch_shipment_dialog {
  .upload-demo {
    /deep/ .el-upload .el-upload-dragger {
      width: 250px;
    }
  }
  .download_template_box {
    position: absolute;
    right: 24px;
    top: 17%;
  }
  .downloadMsgBox {
    width: 100%;
    min-height: 100px;
  }
  .physical_batch_shipment_dialog_floor {
    text-align: right;
    width: 100%;
  }
}
/deep/.system-dialog {
  .el-dialog__body {
    padding: 16px 30px 30px 30px;
  }
  .form-box {
    padding-top: 16px;
    .form-item {
      font-size: 14px;
      color: #333;
      margin-bottom: 12px;
      .item-label {
        display: inline-block;
        width: 76px;
        text-align: right;
      }
      .item-label2 {
        display: inline-block;
        width: 100px;
        text-align: right;
      }
      .item-value {
        display: inline-block;
      }
    }
  }
  .save-btn {
    text-align: center;
  }
}
.table-box {
  padding: 0 30px;
  &-bottom {
    margin: 16px 0 20px 0;
  }
}
.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>
